const childrenLoaded = require('@alexspirgel/children-loaded');
const $ = jQuery;

class ComponentPopover extends HTMLDivElement {

	constructor() {
		super();
	}

	async connectedCallback() {
		await childrenLoaded(this);
		this.initialize();
	}

	initialize() {

		if (this.initialized) {
			return;
		}

		this.initializePopover();

		this.initialized = true;

	}

  initializePopover() {
    $(window).on('dialogopen', (e) => {
      $('html').addClass('has-dialog');
      $('body').addClass('has-dialog');
    });
    $(window).on('dialog:afterclose', (e) => {
      $('html').removeClass('has-dialog');
      $('body').removeClass('has-dialog');
    });
	}

}

customElements.define('component-popover', ComponentPopover, {extends: 'div'});